<app-page-meta pageTitle="finzy - Investor Dashboard"></app-page-meta>
<app-header></app-header>

<div class="main-wrapper" *ngIf="lenderBasicInfo">
<section class="container" [ngClass]="isPortfolioPresent ? 'container-for-portfolio' : ''">
  <img
    class="img-conatiner"
    [ngClass]="isPortfolioPresent ? 'check-circular-svg' : ''"
    [src]="kycStatusImage"
  />
  <span
    [ngClass]="isPortfolioPresent ? 'fund-alloc-verified-info' : ''"
    class="Your-Account-Verific-Title"
    [class.kyc-verified]="
      lenderBasicInfo?.lenderApplicationStatus == 'verified'
    "
  >
    {{ lenderApplicationStatus }}
  </span>
  <span
    class="add-fund-txt"
    *ngIf="lenderBasicInfo?.lenderApplicationStatus == 'verified'"
  >
    Add funds to your investment wallet
  </span>

  <span
    class="review-text"
    *ngIf="
      lenderBasicInfo?.lenderApplicationStatus == 'ready_for_kyc' ||
      lenderBasicInfo?.lenderApplicationStatus === 'kyc_in_progress'
    "
  >
    The review of the KYC documents you submitted is in progress <br />We will
    send you an update in
    <span class="review-text-black">1 business day</span>
    on your registered email id and phone number.
  </span>
  <span
    class="review-text"
    *ngIf="
      lenderBasicInfo?.lenderApplicationStatus == 'verified' ||
      isPortfolioPresent
    "
  >
    Your KYC verification is successfully completed and you are set to invest on
    finzy!
    <br />Please top-up your investment wallet to begin investing.
  </span>
  <app-invest-perference
    *ngIf="isPreferenceSet && !isPortfolioPresent"
    [preferenceValue]="preferenceValue"
    [productDataForNCash]="this.productDataForNCash"
    [productDataForSwift]="this.productsDataForSwift"
  ></app-invest-perference>
  <span
    class="review-text mt-10"
    *ngIf="preferenceValue.walletAmount <= 0"
  >
    In the meanwhile to know more about our product  <a class="review-text-blue" target="_blank" href="/faq?selectedTab=FINZY_FLEX">click here.</a>
    You can also start <span class="review-text-black">Adding Funds</span> to your investment wallet.
  </span>
  <span
    class="review-text mt-10"
    *ngIf="preferenceValue.walletAmount > 0"
  >
  Note: To start investing in <span class="review-text-black">finzyFLEX</span> you will require a minimum balance of <span class="review-text-black">₹50,000</span>.<br> Click here to <a class="review-text-blue" (click)="onAddMoneyClicked()">Add Money</a> to wallet
  </span>
  <button
    type="submit"
    mat-flat-button
    class="add-fund-btn"
    (click)="onAddMoneyClicked()"
    *ngIf="preferenceValue.walletAmount <= 0 && !isPortfolioPresent"
  >
    ADD MONEY
  </button>
</section>
<!-- <div class="fund-alloc" *ngIf="isPortfolioPresent">
  <app-fund-allocation
  [lenderBasicInfo]="this.lenderBasicInfo"
  [productsData]="this.listOfAllSubProduct"
  ></app-fund-allocation>
</div> -->
</div>
<app-footer></app-footer>
